<template>
  <div>
    <div class="form-group form-group-border-bottom align-items-center d-flex flex-row position-relative" dir="rtl">
      <label  v-if="label">
        <span v-if="field.required" class="required">*</span>{{label}}
    </label>
    <!-- Use native select on mobile to avoid iOS datalist hang issue -->
    <select v-if="isMobile" class="form-control-plaintext formselect flex-grow-1" :id="`${name}_select`" :name="name" :required="field.required" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid" :aria-required="fieldAriaRequired" @change="handleSelectChange" @blur="handleBlur">
      <option value="">{{ label }}</option>
      <option v-for="opt in options" :value="opt.text" :key="opt.val" :selected="opt.text === selected">{{opt.text}}</option>
    </select>
    <!-- Use datalist on desktop -->
    <template v-else>
      <input ref="inputField" type="text" class="form-control-plaintext formselect flex-grow-1" :list="datalistId" :id="name" :name="name" :required="field.required" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid" :aria-required="fieldAriaRequired" @focus="handleFocus" @blur="handleBlur" @input="handleInput">
      <datalist :id="datalistId" dir="rtl" style="text-align:right;">
        <option v-for="opt in options" :value="opt.text" :key="opt.val"></option>
      </datalist>
    </template>
    <CaretComponent :open="open" @click="focusInput" class="caret-clickable" />
    </div> 
    <div class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import formFieldA11y from '@/mixins/formFieldA11y.js'

export default {
  mixins: [formFieldA11y],
  components: {
    CaretComponent
  },
  props: {
    label: String,
    type: String,
    name: String,
    selected: String,
    options: {
      type: Array,
      default: () => []
    },
    field: Object,
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      isMobile: false
    }
  },
  computed: {
    datalistId() {
      return `datalistOptions_${this.name}`;
    }
  },
  mounted() {
    // Detect mobile devices - check for navigator to avoid build-time errors
    if (typeof navigator !== 'undefined') {
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }
  },
  methods: {
    handleFocus() {
      this.open = true;
    },
    handleBlur() {
      this.open = false;
    },
    handleInput() {
      // Keep dropdown open while user is typing
      this.open = true;
    },
    handleSelectChange() {
      // Handle select change on mobile
      this.open = false;
    },
    focusInput() {
      if (!this.isMobile && this.$refs.inputField) {
        this.$refs.inputField.focus();
      }
    }
  }
}
</script>
<style scoped>
.formselect {
  display: block;
  padding: 0.375rem 0.75rem 0.375rem 2.5rem;
  -moz-padding-start: calc(0.75rem - 3px);
  background-color: inherit;
  border: 0;
  min-height: 39px;
  max-width: 400px;
}

/* Hide the native datalist dropdown indicator (caret) for Chrome/Safari/Edge */
.formselect::-webkit-calendar-picker-indicator {
  display: none !important;
  -webkit-appearance: none !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
}

.formselect::-webkit-list-button {
  display: none !important;
  -webkit-appearance: none !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* For Firefox - hide datalist indicator */
.formselect {
  -moz-appearance: none;
  appearance: none;
}
.formselect::-moz-list-bullet {
  display: none;
}

/* For IE/Edge */
.formselect::-ms-expand {
  display: none;
}

.formselect:focus,
.formselect:active {
  border: 0;
  outline: none;
}

.formselect:focus-visible {
  outline: 2px solid #ef3d49;
  outline-offset: 2px;
}

.caret-clickable {
  cursor: pointer;
  pointer-events: auto;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.caret-position {
  position: relative;
  top: -3px;
}
.required {
  color: red;
  margin-left: 5px;
}

@media (min-width: 1200px) {
  .caret-position {
    top: inherit;
  }
}
</style>